export const modalConfig = {
  width: 600,
  height: 'auto' as const,
  contentPadding: { vertical: 24, horizontal: 16 },
  modalProps: { destroyOnClose: true },
};

export const getModalFooterButtons = (
  onCancel: () => void,
  onConfirm: () => void
) => [
  { key: 'cancel', text: '取消', type: 'default' as const, onClick: onCancel },
  { key: 'confirm', text: '确定', type: 'primary' as const, onClick: onConfirm },
];

export const getModalTitle = (isEditing: boolean) =>
  isEditing ? '编辑思考方式' : '新建思考方式';
